<template>
  <v-card>
    <v-card-title>
      <v-icon class="mr-3" style="background:#e7e8e9;padding:10px;border-radius:50%;">
        mdi-file-document-outline
      </v-icon>
      <span>{{ editedItem ? 'Editar Pago' : 'Nuevo Pago' }}</span>
    </v-card-title>
    <v-divider />

    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-autocomplete
                  v-model="form.provider_id"
                  :items="providerList"
                  item-value="id"
                  item-text="name"
                  label="Proveedor"
                  clearable
                />
                <v-autocomplete
                  v-model="form.payment_method"
                  :items="paymentMethodList"
                  item-value="id"
                  item-text="method"
                  label="Método de Pago"
                  clearable
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="20" transition="scale-transition" offset-y min-width="290px">
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.date"
                      label="Fecha de Pago"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    />
                  </template>
                  <v-date-picker v-model="form.date" @input="menuDate = false" />
                </v-menu>
                <v-text-field
                  v-model="amountInput"
                  type="text"
                  label="Monto"
                  inputmode="decimal"
                  pattern="^\\d*\\.?\\d*$"
                  @keydown="blockInvalidAmountKey"
                  @paste="handleAmountPaste"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="form.note" label="Referencia" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card-text>
            <div>
              <strong>Monto: </strong>{{ formatted(form.amount) }} <br />
              <strong>Aplicado: </strong>{{ formatted(appliedAmount) }} <br />
              <strong>Quedan: </strong>
              <span :class="{ 'red--text': remainingAmount < 0 }">
                {{ formatted(remainingAmount) }}
              </span>
            </div>
            <v-alert v-if="errorMessage" type="error" dense text class="mt-4 mb-0">
              {{ errorMessage }}
            </v-alert>

            <v-data-table
              :headers="headers"
              :items="calculatedShoppings"
              item-key="id"
              class="elevation-1 mt-4"
              :loading="shoppingsLoading"
              :options.sync="pagination"
              
            :server-items-length="totalShoppings"
            :footer-props="{'items-per-page-options':[15, 30, 50, totalShoppings]}"
            >
              <template #item.select="{ item }">
                <v-checkbox
                    :input-value="isSelected(item.id)"
                    :disabled="isPueShopping(item)"
                    @change="toggleShopping(item)"
                />
              </template>
              <template #item.applied="{ item }">
                <v-text-field
                  :value="item.applied"
                  type="text"
                  inputmode="decimal"
                  prefix="$"
                  dense
                  single-line
                  hide-details
                  :disabled="!isSelected(item.id)"
                  @input="setShoppingApplied(item, $event)"
                />
              </template>
              <template #item.total="{ item }">
                {{ formatted(item.total) }}
              </template>
              <template #item.newDue="{ item }">
                {{ formatted(item.newDue) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-card-actions>
      <v-menu top offset-x class="hidden-md-and-down">
        <template v-slot:activator="{ on, attrs }">
          <v-btn :color="paymentFileColor" style="font-size:12px;" text v-bind="attrs" v-on="on">
            <v-icon class="mr-2">mdi-attachment</v-icon> Comprobante de Pago
            <v-icon v-if="form.pdf" small class="ml-1">mdi-check-circle</v-icon>
          </v-btn>
        </template>
        <v-card class="pa-3" min-width="320">
          <div v-if="form.pdf" class="mb-2">
            <a :href="liga + 'files/' + form.pdf" target="_blank">Ver comprobante actual</a>
            <v-btn x-small text color="error" class="ml-2" @click="fileRemoved">Quitar</v-btn>
          </div>
          <vue-dropzone ref="paymentDropzone" id="payment-dropzone" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved"/>
        </v-card>
      </v-menu>
      
      <v-menu top offset-x class="hidden-md-and-down" v-if="paymentMethodList.filter(id=>id.id == form.payment_method).map(id=>id.method)[0] == 'Nota de crédito'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn :color="creditNoteFileColor" style="font-size:12px;" text v-bind="attrs" v-on="on">
            <v-icon class="mr-2">mdi-attachment</v-icon> Nota de Crédito
            <v-icon v-if="form.credit_note" small class="ml-1">mdi-check-circle</v-icon>
          </v-btn>
        </template>
        <v-card class="pa-3" min-width="320">
          <div v-if="form.credit_note" class="mb-2">
            <a :href="liga + 'files/' + form.credit_note" target="_blank">Ver nota actual</a>
            <v-btn x-small text color="error" class="ml-2" @click="fileRemoved2">Quitar</v-btn>
          </div>
          <vue-dropzone ref="creditNoteDropzone" id="credit-note-dropzone" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess2" v-on:vdropzone-error="uploadError2" v-on:vdropzone-removed-file="fileRemoved2"/>
        </v-card>
      </v-menu>
      
      <v-spacer />
      <v-btn text @click="close">Cancelar</v-btn>
      <v-btn text v-if="step > 1" @click="step--">Anterior</v-btn>
      <v-btn text v-if="step < 2" @click="step++" :disabled="!canContinue">Siguiente</v-btn>
      <v-btn text color="primary" @click="save" v-if="step === 2" :disabled="isSaving || appliedAmount === 0 || remainingAmount < 0">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: {
    editedItem: Object,
    prefill: Object,
  },
  components: {
        vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
            url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/quotation/files",
            addRemoveLinks: true,
            maxFiles: 1
        },
      pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
      step: 1,
      menuDate: false,
      isSaving: false,
      paymentFileStatus: null,
      creditNoteFileStatus: null,
      form: {
        id: null,
        provider_id: null,
        payment_method: null,
        date: null,
        amount: 0,
        note: "",
        pdf:'',
        credit_note:''
      },
      errorMessage: "",
      selectedShoppings: [],
      selectedAmounts: {},
      prefillApplied: false,
      prefillShopping: null,
      headers: [
        { text: "", value: "select", sortable: false },
        { text: "ID", value: "id" },
        { text: "Factura", value: "invoice" },
        { text: "Fecha", value: "date" },
        { text: "Vencimiento", value: "due_date" },
        { text: "Total", value: "total" },
        { text: "Abonado", value: "applied" },
        { text: "Saldo Pendiente", value: "newDue" },
      ],
    };
  },
  computed: {
    liga(){
      return process.env.VUE_APP_BACKEND_ROUTE
    },
    amountInput: {
      get() {
        return this.form.amount;
      },
      set(val) {
        this.form.amount = this.sanitizeAmount(val);
      },
    },
    totalShoppings(){
      return this.$store.state.shoppings.meta?.total
    },
    providerList() {
      return this.$store.state.provider.providers;
    },
    paymentMethodList() {
      return this.$store.state.payment_method.payment_methods;
    },
    shoppingsLoading() {
      return this.$store.state.shoppings.loading;
    },
    calculatedShoppings() {
      return this.$store.state.shoppings.shoppings.map((s) => {
        const isSelected = this.selectedShoppings.includes(s.id);
        const manualAmount = this.selectedAmounts[s.id];
        const applied = isSelected
          ? this.num(manualAmount !== undefined ? manualAmount : s.applied)
          : 0;

        return {
          ...s,
          applied,
          newDue: Number(s.due || 0) - applied,
        };
      });
    },
    appliedAmount() {
      return this.calculatedShoppings.reduce((sum, s) => sum + (s.applied || 0), 0);
    },
    remainingAmount() {
      return this.num(this.form.amount) - this.appliedAmount;
    },
    canContinue() {
      return this.form.provider_id && (this.form.amount * 1) > 0;
    },
    paymentFileColor() {
      if (this.paymentFileStatus) return this.paymentFileStatus;
      return this.form.pdf ? 'success' : '';
    },
    creditNoteFileColor() {
      if (this.creditNoteFileStatus) return this.creditNoteFileStatus;
      return this.form.credit_note ? 'success' : '';
    },
  },
  watch: {
    prefill: {
      handler(val) {
        this.applyPrefill(val);
      },
      immediate: true,
    },
    "form.provider_id": function (val) {
      if (val) {
        this.loadShoppings(val);
      } else {
        this.selectedShoppings = [];
        this.$store.commit("shoppings/setShoppings", []);
      }
    },
    pagination: {
      handler() {
        if (this.form.provider_id) {
          this.loadShoppings(this.form.provider_id);
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.editedItem) {
      const { provider_payment_items = [] } = this.editedItem;

      this.form = {
        id: this.editedItem.id,
        provider_id: this.editedItem.provider?.id || null,
        payment_method: this.editedItem.payment_method?.id || null,
        date: this.editedItem.date || null,
        amount: parseFloat(this.editedItem.amount || 0),
        note: this.editedItem.note || "",
        pdf: this.editedItem.pdf || "",
        credit_note: this.editedItem.credit_note || "",
      };

      this.selectedShoppings = provider_payment_items.map(i => i.shopping_id);
      this.selectedAmounts = provider_payment_items.reduce((amounts, item) => {
        amounts[item.shopping_id] = parseFloat(item.amount || 0);
        return amounts;
      }, {});

      this.loadShoppings(this.form.provider_id).then(() => {
        const existing = this.$store.state.shoppings.shoppings;

        const updated = existing.map(s => {
          const match = provider_payment_items.find(i => i.shopping_id === s.id);
          return match ? {
            ...s,
            applied: parseFloat(match.amount),
            due: parseFloat(match.due),
            newDue: parseFloat(match.newDue || match.due - match.amount)
          } : s;
        });

        const missing = provider_payment_items
          .filter(i => !existing.some(s => s.id === i.shopping_id))
          .map(i => ({
            id: i.shopping_id,
            invoice: i.invoice || "N/A",
            date: i.date || null,
            due_date: i.due_date || null,
            total: parseFloat(i.total || 0),
            due: parseFloat(i.due || 0),
            applied: parseFloat(i.amount),
            newDue: parseFloat(i.newDue || i.due - i.amount),
            serie: i.serie || null,
          }));

        this.$store.commit("shoppings/setShoppings", [...updated, ...missing]);
      });
    }else if(this.liga=='https://backend.ferreteriaenlinea.com/'||this.liga=='https://suministros.uno/'){
      this.form.payment_method = 3
    }
  },
  methods: {
    mergeEditedPaymentItems(provider_payment_items = []) {
      this.selectedAmounts = provider_payment_items.reduce((amounts, item) => {
        amounts[item.shopping_id] = parseFloat(item.amount || 0);
        return amounts;
      }, {});

      const existing = this.$store.state.shoppings.shoppings || [];

      const updated = existing.map((shopping) => {
        const match = provider_payment_items.find((item) => String(item.shopping_id) === String(shopping.id));
        return match
          ? {
              ...shopping,
              applied: parseFloat(match.amount || 0),
              due: parseFloat(match.due || shopping.due || 0),
              newDue: parseFloat(match.newDue ?? ((match.due || 0) - (match.amount || 0))),
            }
          : shopping;
      });

      const missing = provider_payment_items
        .filter((item) => !existing.some((shopping) => String(shopping.id) === String(item.shopping_id)))
        .map((item) => ({
          id: item.shopping_id,
          invoice: item.invoice || "N/A",
          date: item.date || null,
          due_date: item.due_date || null,
          total: parseFloat(item.total || 0),
          due: parseFloat(item.due || 0),
          applied: parseFloat(item.amount || 0),
          newDue: parseFloat(item.newDue ?? ((item.due || 0) - (item.amount || 0))),
          serie: item.serie || null,
        }));

      this.$store.commit("shoppings/setShoppings", [...updated, ...missing]);
    },
    sanitizeAmount(value) {
      const raw = (value ?? "").toString();
      let cleaned = raw.replace(/[^0-9.]/g, "");
      const firstDot = cleaned.indexOf(".");
      if (firstDot !== -1) {
        cleaned =
          cleaned.slice(0, firstDot + 1) +
          cleaned.slice(firstDot + 1).replace(/\./g, "");
      }
      return cleaned;
    },
    num(value) {
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    },
    blockInvalidAmountKey(event) {
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return;

      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Enter",
      ];
      if (controlKeys.includes(key)) return;

      if (key === ".") {
        if (String(this.form.amount || "").includes(".")) {
          event.preventDefault();
        }
        return;
      }

      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },
    handleAmountPaste(event) {
      const text = event.clipboardData?.getData("text") ?? "";
      const sanitized = this.sanitizeAmount(text);
      event.preventDefault();

      const target = event.target;
      const current = String(this.form.amount ?? "");
      const start = target?.selectionStart ?? current.length;
      const end = target?.selectionEnd ?? current.length;
      const nextValue = current.slice(0, start) + sanitized + current.slice(end);
      this.form.amount = this.sanitizeAmount(nextValue);
    },
    applyPrefill(prefill) {
      if (this.editedItem || this.prefillApplied || !prefill) return;

      const providerId = prefill.provider_id || prefill.provider?.id;
      const shopping = prefill.shopping || null;
      const shoppingId = prefill.shopping_id || shopping?.id;

      if (!providerId) return;

      this.prefillApplied = true;
      this.prefillShopping = shopping ? this.normalizeShopping(shopping) : null;

      this.form.provider_id = providerId;
      if (!this.form.date) {
        this.form.date = this.currentDate();
      }
      if (prefill.amount !== undefined && prefill.amount !== null) {
        this.form.amount = parseFloat(prefill.amount);
      } else if (this.prefillShopping && this.prefillShopping.due !== undefined && this.prefillShopping.due !== null) {
        this.form.amount = parseFloat(this.prefillShopping.due);
      } else if (this.prefillShopping && this.prefillShopping.total !== undefined && this.prefillShopping.total !== null) {
        this.form.amount = parseFloat(this.prefillShopping.total);
      }

      if (shoppingId !== undefined && shoppingId !== null) {
        this.selectedShoppings = [shoppingId];
        this.$set(this.selectedAmounts, shoppingId, this.num(this.form.amount));
      }

      this.$nextTick(() => {
        this.loadShoppings(providerId);
      });
    },
    currentDate() {
      return new Date()
        .toLocaleString("sv-SE", { timeZone: "America/Monterrey" })
        .toString()
        .slice(0, 10);
    },
    normalizeShopping(shopping) {
      const total = shopping.total !== undefined && shopping.total !== null ? shopping.total : 0;
      const due = shopping.due !== undefined && shopping.due !== null ? shopping.due : total;

      return {
        id: shopping.id,
        invoice: shopping.invoice || "N/A",
        date: shopping.date || null,
        due_date: shopping.due_date || null,
        total: parseFloat(total),
        due: parseFloat(due),
        serie: shopping.serie || null,
      };
    },
    injectPrefillShopping() {
      if (!this.prefillShopping) return;

      const existing = this.$store.state.shoppings.shoppings || [];
      const alreadyIncluded = existing.some(
        (s) => s.id == this.prefillShopping.id
      );

      if (!alreadyIncluded) {
        this.$store.commit("shoppings/setShoppings", [...existing, this.prefillShopping]);
      }
    },
    uploadSuccess(file, response) {
      console.log('File Successfully Uploaded with file name: ' + response.file);
      this.form.pdf = response.file;
      this.paymentFileStatus = 'success'
    },
    uploadError() {
      this.paymentFileStatus = 'error'
    },
    uploadSuccess2(file, response) {
      console.log('File Successfully Uploaded with file name: ' + response.file);
      this.form.credit_note = response.file;
      this.creditNoteFileStatus = 'success'
    },
    uploadError2() {
      this.creditNoteFileStatus = 'error'
    },
    fileRemoved() {
        this.form.pdf = '';
        this.paymentFileStatus = null;
    },
    fileRemoved2() {
        this.form.credit_note = '';
        this.creditNoteFileStatus = null;
    },
    formatted(val) {
      return parseFloat(val*1 || 0).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
    loadShoppings(providerId) {
      return this.$store.dispatch("shoppings/getShoppingsByProvider", {
        "filter[provider_id]": providerId,
        "filter[paid]": 'false',
        page: this.pagination.page,
        itemsPerPage: this.pagination.itemsPerPage,
      }).then(() => {
        this.injectPrefillShopping();
        if (this.editedItem?.provider_payment_items?.length) {
          this.mergeEditedPaymentItems(this.editedItem.provider_payment_items);
        }
      });
    },
    isSelected(id) {
      return this.selectedShoppings.includes(id);
    },
    toggleShopping(item) {
      this.errorMessage = "";
      if (this.isPueShopping(item)) {
        this.errorMessage = "No se puede generar complemento de pago para una compra PUE.";
        return;
      }

      const index = this.selectedShoppings.indexOf(item.id);
      if (index >= 0) {
        this.selectedShoppings.splice(index, 1);
        this.$delete(this.selectedAmounts, item.id);
        return;
      }

      this.selectedShoppings.push(item.id);
      const defaultAmount = Math.min(
        Math.max(this.remainingAmount, 0),
        this.num(item.due)
      );
      this.$set(this.selectedAmounts, item.id, defaultAmount);
    },
    setShoppingApplied(item, value) {
      if (!this.isSelected(item.id)) return;

      this.$set(this.selectedAmounts, item.id, this.sanitizeAmount(value));
    },
    isPueShopping(item) {
      return String(item?.serie || "").trim().toUpperCase() === "PUE";
    },
    close() {
      this.$emit("closed");
    },
    save() {
      this.errorMessage = "";
      const selectedPueShopping = this.calculatedShoppings.find((s) => this.isSelected(s.id) && this.isPueShopping(s));
      if (selectedPueShopping) {
        this.errorMessage = "No se puede generar complemento de pago para una compra PUE.";
        return;
      }

      this.isSaving = true;

      const shoppings = this.calculatedShoppings.filter(s => s.applied > 0).map(s => ({
        id: s.id,
        due: s.due,
        amount: s.applied,
        newDue: (s.newDue * 1).toFixed(2),
      }));

      const payload = {
        ...this.form,
        id: this.editedItem?.id || this.form.id,
        shoppings,
      };

      const action = this.editedItem
        ? "providerPayment/updateProviderPayment"
        : "providerPayment/createProviderPayment";

      this.$store
        .dispatch(action, payload)
        .then(() => this.$emit("saved"))
        .finally(() => {
          this.isSaving = false;
          this.close()
        });
    },
  },
};
</script>
